import React from 'react';
import { Box, Typography, Grid, Card, CardContent, IconButton, useTheme } from '@mui/material';
import {
  People as PeopleIcon,
  ChevronRight as ArrowIcon,
  LocalShipping,
  Schedule,
  Groups,
  TipsAndUpdates,
  Dataset,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {
  PageHeader,
} from '../../components/SharedPageParts';

interface DashboardCard {
  title: string;
  subtitle: string;
  icon: React.ReactElement;
  iconBg: string;
  stats?: { label: string; value: number }[];
  action?: { label: string; onClick: () => void };
  path: string;
}

const commonDataCards: DashboardCard[] = [
    {
      title: 'Operators',
      subtitle: 'Manage Operators profiles',
      icon: <PeopleIcon sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      stats: [
        // { label: 'Operators', value: "1" },
        // { label: 'Equipment', value: "2"},
      ],
      path: '/users',
    },
    {
      title: 'Equipments',
      subtitle: 'Manage fleet equipments',
      icon: <LocalShipping sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      stats: [
        // { label: 'Operators', value: "1" },
        // { label: 'Equipment', value: "2"},
      ],
      path: '/commondata/equipments',
    },
    {
      title: 'Shift Timings',
      subtitle: 'Manage Operators profiles',
      icon: <Schedule sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      stats: [
        // { label: 'Operators', value: "1" },
        // { label: 'Equipment', value: "2"},
      ],
      path: '/commondata/shifts',
    },
    {
      title: 'Crew Assignments',
      subtitle: 'Manage Operators profiles',
      icon: <Groups sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      stats: [
        // { label: 'Operators', value: "1" },
        // { label: 'Equipment', value: "2"},
      ],
      path: '/commondata/crew',
    }];
const CommonData: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  
  return (
  <Box sx={{ minHeight: '100vh', backgroundColor: theme.palette.background.default }}>

   <Box className="MuiBox-root-margin" sx={{ px: 1, mx: 'auto'}}>
    <PageHeader
                            title="Common Data"
                            Icon={Dataset}
                            onBack={() => navigate('/')}
                            backLabel="Back to Dashboard"
                            subtitle="Manage Operators, equipments, shifts, and crew assignments"
                          />
    
              <Grid container spacing={3}>
                {commonDataCards.map((card, index) => (
                  <Grid item xs={6} key={index}>
                    <Card
                      sx={{
                        height: '100%',
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        border: `1px solid ${theme.palette.divider}`,
                        '&:hover': { transform: 'translateY(-4px)', boxShadow: theme.palette.mode === 'light' ? '0 12px 24px rgba(0,0,0,0.1)' : '0 12px 24px rgba(0,0,0,0.3)' },
                      }}
                      onClick={() => navigate(card.path)}
                    >
                      <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                          <Box sx={{ width: 56, height: 56, borderRadius: 2, background: card.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                            {card.icon}
                          </Box>
                          <IconButton size="small" sx={{ color: theme.palette.text.secondary }}>
                            <ArrowIcon />
                          </IconButton>
                        </Box>
      
                        <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 600, mb: 1 }}>
                          {card.title}
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2, flexGrow: 1 }}>
                          {card.subtitle}
                        </Typography>
      
                        {card.stats && (
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {card.stats.map((stat, i) => (
                              <Box key={i} sx={{ backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.background.default, px: 2, py: 1, borderRadius: 1, flex: '1 1 auto', minWidth: 60 }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }}>
                                  {stat.label}
                                </Typography>
                                <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 700 }}>
                                  {stat.value}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
      
                        {card.action && (
                          <Box sx={{ mt: 2, pt: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
                            <Typography
                              variant="body2"
                              sx={{ color: '#667eea', fontWeight: 600, cursor: 'pointer' }}
                              onClick={(e) => { e.stopPropagation(); card.action?.onClick(); }}
                            >
                              {card.action.label}
                            </Typography>
                          </Box>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
        <Typography variant="body2" sx={{mt:2, mb:1, pl:1, color: theme.palette.text.secondary}}>
          <TipsAndUpdates sx={{fontSize: '18px', verticalAlign: 'middle', mr: 1}}></TipsAndUpdates>
          Note: Changes made in Common Data will reflect across all relevant sections of the application.
        </Typography>
    </Box>
    
  );
};

export default CommonData;